import { Component, Input } from '@angular/core';
import type { LinkField } from '@sitecore-jss/sitecore-jss-angular';
import { NgClass } from '@angular/common';
import { GenericLinkDirective } from '@core/jss-utils';

@Component({
  selector: 'wl-list',
  templateUrl: './list.component.html',
  styleUrls: ['./list.component.scss'],
  standalone: true,
  imports: [NgClass, GenericLinkDirective],
})
export class ListComponent {
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() list?: LinkField[];

  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() ulClass?: string;

  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() liClass?: string;
}
